document.addEventListener(
	'DOMContentLoaded',
	function () {
		// select elements
		const header = document.querySelector('.header');
		const headerMenu = header.querySelector('.header__menu');
		const headerBtn = header.querySelector('.header__container_button_mobile');
		const headerOverlay = header.querySelector('.header__overlay');

		const scrollTrigger = 0;

		// Get class to check if start tranparent or not
		const headerTransparent = header.classList.contains('start-transparent');

		// To check if main container has show class when open menu
		let needShow = false;

		// toggle nav open/close
		headerBtn.addEventListener('click', function () {
            
			headerBtn.classList.toggle('open');
			headerMenu.classList.toggle('open');
			headerOverlay.classList.toggle('open');

		});

        headerOverlay.addEventListener('click', function () {
            
			headerBtn.classList.remove('open');
			headerMenu.classList.remove('open');
			headerOverlay.classList.remove('open');

		});

		// on window scroll
		if (headerTransparent) {
			window.onscroll = function () {
				checkScrollPosition();
			};
		}

		const checkScrollPosition = () => {
			// make header opaque when scroll down
			if (window.scrollY > scrollTrigger) {
                header.classList.remove("transparent");
			} else {
				header.classList.add("transparent");
			}
		};

		// first check
		if (window.scrollY > scrollTrigger) {
			checkScrollPosition();
		}

        // Abrir submenus
        // Seleciona todos os itens de menu com submenus
        var menuItems = document.querySelectorAll('.header__menu li:has(>.sub-menu)');

        // Adiciona eventos de hover a cada item de menu
        menuItems.forEach(function (menuItem) {
			menuItem.addEventListener('click', function (event) {
				var submenu = menuItem.querySelector('.sub-menu');
				if (submenu) {
					submenu.classList.toggle("hover");
				}
            });   
        });

    },
	false
);
